export default __webpack_public_path__ + "img/eXXdcqzT.2eda550f.svg";